import SavedReportList, { SavedReportListProps } from 'common/pages/saved-report/SavedReportList.tsx'

export const SavedReportListAdvertiser = (props: SavedReportListProps) => <SavedReportList {...props} />
